export default __webpack_public_path__ + "static/media/notificationWhite.50d4d4d2.svg";